import { render, staticRenderFns } from "./SocialMediaShareElement.vue?vue&type=template&id=b00cd8e4&"
import script from "./SocialMediaShareElement.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaShareElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports